import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import WhyStand from '../components/WhyStand';
import WaysToStand from '../components/WaysToStand';
import Impact from '../components/Impact';
import LiveDonationDashboard from '../components/LiveDonationDashboard';
import CommunityMap from '../components/CommunityMap';
import DigitalResources from '../components/DigitalResources';
import Stories from '../components/Stories';
import Donate from '../components/Donate';
import Events from '../components/Events';
import Sponsors from '../components/Sponsors';
import { FinalCTA, Footer } from '../components/Footer';

const TakeAStand = () => {
  return (
    <main className="font-body text-[#0E1A1B]">
      <Navbar />
      <Hero />
      <WhyStand />
      <WaysToStand />
      <Impact />
      <LiveDonationDashboard />
      <Stories />
      <Donate />
      <CommunityMap />
      <Events />
      <DigitalResources />
      <Sponsors />
      <FinalCTA />
      <Footer />
    </main>
  );
};

export default TakeAStand;
